import Image from 'next/image'
import React from 'react'

import { PopupBanners } from '@/widgets/Header/ui/popup-banners/popup-banners'
import { PopupBrands } from '@/widgets/Header/ui/popup-brands/popup-brands'

import { BASE_URL } from '@/shared/lib/const/env'
import { TBurgerLevel2 } from '@/shared/types/deprecated-types'
import { UnderlineLink } from '@/shared/ui'

import cl from './style.module.scss'

interface PopupListProps {
	items: TBurgerLevel2[]
}

export const PopupList = (props: PopupListProps) => {
	const { items } = props

	return (
		<div className={cl.column}>
			{items.map((item, index) => {
				if (item.TYPE === 'brands') return <PopupBrands key={JSON.stringify(item)} items={[item]} />
				if (item.TYPE === 'banner') return <PopupBanners key={JSON.stringify(item)} items={[item]} />
				if (item.HIDDEN) return
				return (
					<div className={cl.wrapper} key={item.SECTION_LINK + index}>
						{item.PICTURE && <Image src={BASE_URL + item.PICTURE} alt={''} width={32} height={32} className={cl.img} />}
						<ul className={cl.list}>
							{item.SECTION_LINK && (
								<li className={cl.item}>
									<UnderlineLink
										style={{ width: 'fit-content', display: 'block' }}
										href={item.SECTION_LINK}
										prefetch={false}>
										<p className={cl.title}>{item.NAME}</p>
									</UnderlineLink>
								</li>
							)}
							{!item.SECTION_LINK && <h4 className={cl.title__withoutLink}>{item.NAME}</h4>}
							{item.LINKS.map(item => (
								<li key={item.LINK} className={cl.item}>
									<UnderlineLink
										style={{ width: 'fit-content', display: 'block' }}
										href={item.LINK}
										key={item.LINK}
										prefetch={false}>
										{item.NAME}
									</UnderlineLink>
								</li>
							))}
						</ul>
					</div>
				)
			})}
		</div>
	)
}
